export enum ShopIntegrationType {
  RosaOne = 'rosa_one',
}
